import { compressAndResize } from './image.utils';

const IMAGE_MAX_DIMENSION = 1600;
const THUMBNAIL_MAX_DIMENSION = 300;
const JPEG_MIME_TYPE = 'image/jpeg';

export interface PreparedPhoto {
  imageBlob: Blob;
  thumbnailBlob: Blob;
  imageDataUrl: string;
}

export function isImageFile(file: File): boolean {
  const isImage = file.type.startsWith('image/');

  return isImage;
}

export async function preparePhoto(file: File): Promise<PreparedPhoto> {
  const imageDataUrl = await compressAndResize(file, IMAGE_MAX_DIMENSION, IMAGE_MAX_DIMENSION);
  const thumbnailDataUrl = await compressAndResize(file, THUMBNAIL_MAX_DIMENSION, THUMBNAIL_MAX_DIMENSION);

  return {
    imageBlob: dataUrlToBlob(imageDataUrl),
    thumbnailBlob: dataUrlToBlob(thumbnailDataUrl),
    imageDataUrl: imageDataUrl,
  };
}

function dataUrlToBlob(dataUrl: string): Blob {
  const base64 = dataUrl.slice(dataUrl.indexOf(',') + 1);
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index++) {
    bytes[index] = binary.codePointAt(index) ?? 0;
  }

  return new Blob([bytes], { type: JPEG_MIME_TYPE });
}
